{
  "tag_categories": {
    "cultural_background": {
      "name": "Cultural Background",
      "description": "Share your cultural heritage to connect with students from diverse backgrounds and enrich the learning experience.",
      "tag_subcategories": {
        "indigenous_first_nations": {
          "name": "Indigenous/First Nations",
          "tags": {
            "australian_aboriginal": {
              "name": "Australian Aboriginal"
            },
            "torres_strait_islander": {
              "name": "Torres Strait Islander"
            },
            "maori": {
              "name": "Māori"
            },
            "native_american": {
              "name": "Native American"
            },
            "indigenous_general": {
              "name": "Indigenous (General)"
            }
          }
        },
        "international_ethnic_backgrounds": {
          "name": "International/Ethnic Backgrounds",
          "tags": {
            "african": {
              "name": "African"
            },
            "asian_east_south_southeast": {
              "name": "Asian (East, South, Southeast)"
            },
            "european_eastern_western": {
              "name": "European (Eastern, Western)"
            },
            "latin_american": {
              "name": "Latin American"
            },
            "middle_eastern": {
              "name": "Middle Eastern"
            },
            "pacific_islander": {
              "name": "Pacific Islander"
            },
            "caribbean": {
              "name": "Caribbean"
            },
            "multicultural": {
              "name": "Multicultural"
            }
          }
        }
      }
    },
    "religious_background": {
      "name": "Religious Background",
      "description": "Optionally share your religious or spiritual affiliations, important for students and families seeking alignment with personal values.",
      "tag_subcategories": {
        "abrahamic_religions": {
          "name": "Abrahamic Religions",
          "tags": {
            "christianity_catholic_protestant_orthodox_baptist_pentecostal": {
              "name": "Christianity (Catholic, Protestant, Orthodox, Baptist, Pentecostal)"
            },
            "islam_sunni_shia": {
              "name": "Islam (Sunni, Shia)"
            },
            "judaism_orthodox_conservative_reform": {
              "name": "Judaism (Orthodox, Conservative, Reform)"
            }
          }
        },
        "dharmic_religions": {
          "name": "Dharmic Religions",
          "tags": {
            "buddhism": {
              "name": "Buddhism"
            },
            "hinduism": {
              "name": "Hinduism"
            },
            "sikhism": {
              "name": "Sikhism"
            }
          }
        },
        "other_beliefs": {
          "name": "Other Beliefs",
          "tags": {
            "atheist": {
              "name": "Atheist"
            },
            "agnostic": {
              "name": "Agnostic"
            },
            "spiritual_non_denominational": {
              "name": "Spiritual (Non-denominational)"
            },
            "no_affiliation": {
              "name": "No Affiliation"
            }
          }
        }
      }
    },
    "experience_level": {
      "name": "Experience & Qualifications",
      "description": "Highlight your professional journey, including seniority, years of experience, and academic credentials.",
      "tag_subcategories": {
        "seniority": {
          "name": "Seniority",
          "tags": {
            "graduate_teacher_0_2_years": {
              "name": "Graduate Teacher (0-2 years)"
            },
            "early_career_teacher_3_5_years": {
              "name": "Early Career Teacher (3-5 years)"
            },
            "experienced_teacher_6_15_years": {
              "name": "Experienced Teacher (6-15 years)"
            },
            "senior_teacher_15_years": {
              "name": "Senior Teacher (15+ years)"
            },
            "lead_teacher": {
              "name": "Lead Teacher"
            },
            "head_of_department": {
              "name": "Head of Department"
            },
            "curriculum_coordinator": {
              "name": "Curriculum Coordinator"
            },
            "principal_assistant_principal_former": {
              "name": "Principal/Assistant Principal (Former)"
            }
          }
        },
        "qualifications": {
          "name": "Qualifications",
          "tags": {
            "certified_teacher": {
              "name": "Certified Teacher"
            },
            "licensed_educator": {
              "name": "Licensed Educator"
            },
            "doctorate_ph_d_ed_d": {
              "name": "Doctorate (Ph.D., Ed.D.)"
            },
            "master_s_degree": {
              "name": "Master's Degree"
            },
            "bachelor_s_degree": {
              "name": "Bachelor's Degree"
            },
            "special_education_certified": {
              "name": "Special Education Certified"
            }
          }
        }
      }
    },
    "student_experience": {
      "name": "Student Experience",
      "description": "Indicate your expertise in teaching diverse student populations and addressing specific learning needs.",
      "tag_subcategories": {
        "learning_differences_disabilities": {
          "name": "Learning Differences/Disabilities",
          "tags": {
            "adhd_add": {
              "name": "ADHD/ADD"
            },
            "dyslexia": {
              "name": "Dyslexia"
            },
            "dyscalculia": {
              "name": "Dyscalculia"
            },
            "autism_spectrum_asd": {
              "name": "Autism Spectrum (ASD)"
            },
            "intellectual_disability": {
              "name": "Intellectual Disability"
            },
            "learning_difficulties_general": {
              "name": "Learning Difficulties (General)"
            }
          }
        },
        "sensory_impairments": {
          "name": "Sensory Impairments",
          "tags": {
            "visually_impaired_blind": {
              "name": "Visually Impaired/Blind"
            },
            "hearing_impaired_deaf": {
              "name": "Hearing Impaired/Deaf"
            }
          }
        },
        "gifted_talented": {
          "name": "Gifted & Talented",
          "tags": {
            "gifted_students": {
              "name": "Gifted Students"
            },
            "high_achievers": {
              "name": "High Achievers"
            },
            "advanced_placement_ap_students": {
              "name": "Advanced Placement (AP) Students"
            },
            "international_baccalaureate_ib_students": {
              "name": "International Baccalaureate (IB) Students"
            }
          }
        },
        "diverse_demographics": {
          "name": "Diverse Demographics",
          "tags": {
            "male_students": {
              "name": "Male Students"
            },
            "female_students": {
              "name": "Female Students"
            },
            "non_binary_students": {
              "name": "Non-binary Students"
            },
            "esl_eal_students": {
              "name": "ESL/EAL Students"
            },
            "low_socio_economic_background_students": {
              "name": "Low Socio-Economic Background Students"
            },
            "at_risk_students": {
              "name": "At-Risk Students"
            },
            "students_with_anxiety": {
              "name": "Students with Anxiety"
            },
            "students_with_depression": {
              "name": "Students with Depression"
            },
            "students_with_chronic_illness": {
              "name": "Students with Chronic Illness"
            },
            "neurodiverse_students": {
              "name": "Neurodiverse Students"
            }
          }
        }
      }
    },
    "subject_focus": {
      "name": "Subject Area Focus",
      "description": "Select the academic disciplines where you have expertise, relevant for Year 11-12 curricula and beyond.",
      "tag_subcategories": {
        "stem_steam": {
          "name": "STEM/STEAM",
          "tags": {
            "science_biology_chemistry_physics_environmental": {
              "name": "Science (Biology, Chemistry, Physics, Environmental)"
            },
            "technology_digital_programming_cybersecurity": {
              "name": "Technology (Digital, Programming, Cybersecurity)"
            },
            "engineering_design_studies": {
              "name": "Engineering (Design, Studies)"
            },
            "mathematics_advanced_general_specialist_stats_calc_alg": {
              "name": "Mathematics (Advanced, General, Specialist, Stats, Calc, Alg)"
            },
            "arts_integrated_with_stem": {
              "name": "Arts (integrated with STEM)"
            }
          }
        },
        "arts_humanities": {
          "name": "Arts & Humanities",
          "tags": {
            "english_literature_advanced_esl": {
              "name": "English (Literature, Advanced, ESL)"
            },
            "history_ancient_modern_legal_society_culture": {
              "name": "History (Ancient, Modern, Legal, Society & Culture)"
            },
            "geography": {
              "name": "Geography"
            },
            "philosophy": {
              "name": "Philosophy"
            },
            "religious_studies": {
              "name": "Religious Studies"
            },
            "languages_french_german_spanish_mandarin_japanese_indigenous": {
              "name": "Languages (French, German, Spanish, Mandarin, Japanese, Indigenous)"
            },
            "visual_arts": {
              "name": "Visual Arts"
            },
            "performing_arts_drama_music": {
              "name": "Performing Arts (Drama, Music)"
            },
            "media_studies": {
              "name": "Media Studies"
            }
          }
        },
        "business_economics": {
          "name": "Business & Economics",
          "tags": {
            "business_studies": {
              "name": "Business Studies"
            },
            "economics": {
              "name": "Economics"
            },
            "accounting": {
              "name": "Accounting"
            },
            "legal_studies_business": {
              "name": "Legal Studies (Business)"
            },
            "commerce": {
              "name": "Commerce"
            }
          }
        },
        "health_pe": {
          "name": "Health & PE",
          "tags": {
            "physical_education": {
              "name": "Physical Education"
            },
            "health_studies": {
              "name": "Health Studies"
            },
            "psychology": {
              "name": "Psychology"
            }
          }
        },
        "vocational_applied": {
          "name": "Vocational & Applied",
          "tags": {
            "vet": {
              "name": "VET"
            },
            "applied_learning": {
              "name": "Applied Learning"
            },
            "life_skills": {
              "name": "Life Skills"
            }
          }
        }
      }
    },
    "teaching_style": {
      "name": "Teaching Style & Philosophy",
      "description": "Describe your pedagogical approach and educational philosophy to help students find a learning environment that resonates with them.",
      "tag_subcategories": {
        "pedagogical_approaches": {
          "name": "Pedagogical Approaches",
          "tags": {
            "blended_learning": {
              "name": "Blended Learning"
            },
            "flipped_classroom": {
              "name": "Flipped Classroom"
            },
            "project_based_learning_pbl": {
              "name": "Project-Based Learning (PBL)"
            },
            "inquiry_based_learning": {
              "name": "Inquiry-Based Learning"
            },
            "socratic_method": {
              "name": "Socratic Method"
            },
            "differentiated_instruction": {
              "name": "Differentiated Instruction"
            },
            "student_centered_learning": {
              "name": "Student-Centered Learning"
            },
            "direct_instruction": {
              "name": "Direct Instruction"
            },
            "experiential_learning": {
              "name": "Experiential Learning"
            },
            "competency_based_learning": {
              "name": "Competency-Based Learning"
            },
            "gamification": {
              "name": "Gamification"
            },
            "growth_mindset_approach": {
              "name": "Growth Mindset Approach"
            },
            "collaborative_learning": {
              "name": "Collaborative Learning"
            },
            "personalized_learning": {
              "name": "Personalized Learning"
            }
          }
        },
        "global_cultural_focus": {
          "name": "Global & Cultural Focus",
          "tags": {
            "global_virtual_exchange": {
              "name": "Global Virtual Exchange"
            },
            "intercultural_communication": {
              "name": "Intercultural Communication"
            },
            "culturally_responsive_teaching": {
              "name": "Culturally Responsive Teaching"
            },
            "trauma_informed_teaching": {
              "name": "Trauma-Informed Teaching"
            }
          }
        },
        "assessment_philosophy": {
          "name": "Assessment Philosophy",
          "tags": {
            "formative_assessment_focus": {
              "name": "Formative Assessment Focus"
            },
            "summative_assessment_focus": {
              "name": "Summative Assessment Focus"
            },
            "authentic_assessment": {
              "name": "Authentic Assessment"
            },
            "criterion_referenced_assessment": {
              "name": "Criterion-Referenced Assessment"
            }
          }
        }
      }
    },
    "learning_tech": {
      "name": "Learning Enhancement Technology",
      "description": "List the digital tools and platforms you are proficient in, essential for online, hybrid, or technology-rich learning.",
      "tag_subcategories": {
        "lms": {
          "name": "LMS",
          "tags": {
            "canvas": {
              "name": "Canvas"
            },
            "moodle": {
              "name": "Moodle"
            },
            "google_classroom": {
              "name": "Google Classroom"
            },
            "microsoft_teams_for_education": {
              "name": "Microsoft Teams for Education"
            },
            "schoology": {
              "name": "Schoology"
            }
          }
        },
        "collaboration_tools": {
          "name": "Collaboration Tools",
          "tags": {
            "zoom": {
              "name": "Zoom"
            },
            "google_meet": {
              "name": "Google Meet"
            },
            "microsoft_teams": {
              "name": "Microsoft Teams"
            },
            "slack": {
              "name": "Slack"
            },
            "padlet": {
              "name": "Padlet"
            },
            "jamboard": {
              "name": "Jamboard"
            }
          }
        },
        "content_creation": {
          "name": "Content Creation",
          "tags": {
            "nearpod": {
              "name": "Nearpod"
            },
            "edpuzzle": {
              "name": "Edpuzzle"
            },
            "kahoot": {
              "name": "Kahoot!"
            },
            "quizlet": {
              "name": "Quizlet"
            },
            "gimkit": {
              "name": "Gimkit"
            },
            "prezi": {
              "name": "Prezi"
            },
            "canva_for_education": {
              "name": "Canva for Education"
            }
          }
        },
        "digital_whiteboards": {
          "name": "Digital Whiteboards",
          "tags": {
            "miro": {
              "name": "Miro"
            },
            "whiteboard_chat": {
              "name": "Whiteboard.chat"
            }
          }
        },
        "specialized_tech": {
          "name": "Specialized Tech",
          "tags": {
            "virtual_reality_vr": {
              "name": "Virtual Reality (VR)"
            },
            "augmented_reality_ar": {
              "name": "Augmented Reality (AR)"
            },
            "coding_platforms": {
              "name": "Coding Platforms"
            },
            "stem_simulation_software": {
              "name": "STEM Simulation Software"
            },
            "graphic_calculators": {
              "name": "Graphic Calculators"
            },
            "assistive_technologies": {
              "name": "Assistive Technologies"
            }
          }
        }
      }
    },
    "additional_tags": {
      "name": "Additional Support & Logistics",
      "description": "Cover practical aspects of your teaching service, including delivery methods, scheduling, and specialized support.",
      "tag_subcategories": {
        "teaching_modality": {
          "name": "Teaching Modality",
          "tags": {
            "in_person": {
              "name": "In-person"
            },
            "online_live_synchronous": {
              "name": "Online (Live/Synchronous)"
            },
            "online_self_paced_asynchronous": {
              "name": "Online (Self-paced/Asynchronous)"
            },
            "hybrid": {
              "name": "Hybrid"
            },
            "blended": {
              "name": "Blended"
            }
          }
        },
        "availability_flexibility": {
          "name": "Availability & Flexibility",
          "tags": {
            "flexible_scheduling": {
              "name": "Flexible Scheduling"
            },
            "weekend_availability": {
              "name": "Weekend Availability"
            },
            "evening_sessions": {
              "name": "Evening Sessions"
            },
            "quick_response_time": {
              "name": "Quick Response Time"
            },
            "group_classes_available": {
              "name": "Group Classes Available"
            },
            "one_on_one_sessions": {
              "name": "One-on-One Sessions"
            }
          }
        },
        "assessment_feedback": {
          "name": "Assessment & Feedback",
          "tags": {
            "regular_progress_reports": {
              "name": "Regular Progress Reports"
            },
            "detailed_written_feedback": {
              "name": "Detailed Written Feedback"
            },
            "verbal_feedback": {
              "name": "Verbal Feedback"
            },
            "portfolio_based_assessment": {
              "name": "Portfolio-Based Assessment"
            },
            "exam_preparation_specialist": {
              "name": "Exam Preparation Specialist"
            },
            "essay_writing_feedback": {
              "name": "Essay Writing Feedback"
            }
          }
        },
        "curricula_expertise": {
          "name": "Curricula Expertise",
          "tags": {
            "hsc_nsw": {
              "name": "HSC (NSW)"
            },
            "vce_vic": {
              "name": "VCE (VIC)"
            },
            "qce_qld": {
              "name": "QCE (QLD)"
            },
            "sace_sa": {
              "name": "SACE (SA)"
            },
            "wace_wa": {
              "name": "WACE (WA)"
            },
            "tce_tas": {
              "name": "TCE (TAS)"
            },
            "ntcet_nt": {
              "name": "NTCET (NT)"
            },
            "act_bsss": {
              "name": "ACT BSSS"
            },
            "ib_diploma": {
              "name": "IB Diploma"
            },
            "cambridge_igcse_a_levels": {
              "name": "Cambridge IGCSE/A-Levels"
            },
            "gamsat_prep": {
              "name": "GAMSAT Prep"
            },
            "ucat_prep": {
              "name": "UCAT Prep"
            }
          }
        },
        "extracurricular_support": {
          "name": "Extracurricular Support",
          "tags": {
            "career_guidance": {
              "name": "Career Guidance"
            },
            "university_application_support": {
              "name": "University Application Support"
            },
            "mentoring": {
              "name": "Mentoring"
            },
            "wellbeing_support": {
              "name": "Wellbeing Support"
            },
            "study_skills_coaching": {
              "name": "Study Skills Coaching"
            },
            "time_management_coaching": {
              "name": "Time Management Coaching"
            }
          }
        }
      }
    }
  }
}
